var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.472,
    height: 96,
    viewBox: "0 0 87.472 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.472,
    height: 96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.985,65.423,36.735,54.985a5.017,5.017,0,1,0-7.159,7.03l2.411,2.455a28.84,28.84,0,0,1-2.124,5.368C23.035,78.914,1.427,105,1.427,105a4.952,4.952,0,0,0,.424,6.447l.483.492a9.827,9.827,0,0,0,.481,13.242h0a9.827,9.827,0,0,0,13.23.723l.379.386a4.953,4.953,0,0,0,6.427.55s1.884-1.493,4.825-3.812c2.875,2.084,5.436,5.43,10.175,10.143,6.936,6.9,13.2,6.3,15.981-.677s-2.619-10.811-9.351-13.014a23.124,23.124,0,0,1-7.214-3.983c7.886-6.167,16.979-13.205,21.655-16.57a25.8,25.8,0,0,1,5.122-1.808l2.414,2.458a5.017,5.017,0,1,0,7.159-7.03L63.367,82.108A11.811,11.811,0,0,0,46.985,65.423",
    transform: "translate(0 -42.044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.856,18.851a1.821,1.821,0,0,1-1.768-2.252l3.726-15.213a1.819,1.819,0,0,1,3.533.865l-3.726,15.213a1.82,1.82,0,0,1-1.765,1.387",
    transform: "translate(-190.268 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.352,151.656a1.819,1.819,0,0,1-.266-3.618l15.491-2.309a1.819,1.819,0,0,1,.536,3.6l-15.491,2.309a1.838,1.838,0,0,1-.271.02",
    transform: "translate(-251.193 -114.545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.189,68.816a1.819,1.819,0,0,1-1.558-2.755l1.734-2.891a1.819,1.819,0,0,1,3.119,1.871l-1.734,2.891a1.818,1.818,0,0,1-1.561.883",
    transform: "translate(-214.903 -48.965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.783,125.8a1.819,1.819,0,0,1-.8-3.453l2.615-1.279a1.819,1.819,0,0,1,1.6,3.268l-2.615,1.279a1.812,1.812,0,0,1-.8.185",
    transform: "translate(-248.384 -95.03)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.621,94.637a1.819,1.819,0,0,1-1.2-3.185L300,89.185a1.819,1.819,0,1,1,2.4,2.732l-2.578,2.267a1.812,1.812,0,0,1-1.2.453",
    transform: "translate(-233.321 -69.754)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon);
export default __webpack_public_path__ + "static/media/campaign_icon.1c5fa015fde47c6f1f9b7b9695cedf17.svg";
export { ForwardRef as ReactComponent };